import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Decision } from './Decision';

export const DecisionPage = () => {
  return (
    <Layout withFooter>
      <Decision />
    </Layout>
  );
};
